export const STATUS_NONE = 1
export const STATUS_PORTED_OUT = 3
